<template>
  <section>
    <div class="section-header">
      <h2>Plan Designs</h2>
      <div class="btn-wrap">
        <div class="section-header-desc">
          <p>
            You cannot see more than 3 alternative designs at the same time.
          </p>
          <p>
            Please, archive or delete one or several designs to be able to add
            another one.
          </p>
        </div>
        <roe-archived-designs
          :can-add-current-design="canAddCurrentDesign"
        ></roe-archived-designs>
        <button
          class="btn-secondary btn-secondary-"
          @click="
            canAddCurrentDesign();
            addNew();
          "
        >
          Add New
        </button>
      </div>
    </div>

    <roe-edit-plan-design-name
      ref="editPlanDesignNameForm"
    ></roe-edit-plan-design-name>

    <div class="section-content">
      <div class="table-wrap">
        <div class="table">
          <div class="table-row table-head">
            <div class="table-head-unit">
              <div
                class="plan-header-light"
                @click="changeHighlightDifferences"
              >
                {{
                  highlightDifferences
                    ? "Don't highlight differences"
                    : "Highlight differences "
                }}
              </div>
            </div>
            <div
              class="table-head-unit"
              v-for="(design, index) in designs"
              v-if="design"
            >
              <div class="plan-header" :class="`plan-header-${index}`">
                {{ design.name }}
                <roe-design-actions
                  :current-design="design"
                  v-on:open-edit-name="openEditNameForm"
                  v-if="index !== 0"
                ></roe-design-actions>
              </div>
            </div>
          </div>
          <roe-age-requirement :designs="designs"></roe-age-requirement>
          <roe-service-requirement :designs="designs"></roe-service-requirement>
          <roe-auto-enrollment :designs="designs"></roe-auto-enrollment>
          <roe-auto-escalation :designs="designs"></roe-auto-escalation>
          <roe-employer-match :designs="designs"></roe-employer-match>
          <roe-employer-other :designs="designs"></roe-employer-other>
        </div>
        <div class="table-footer">
          <button class="btn-primary" @click="calculateSaving">
            <roe-three-dots-animation v-if="calculating"
              >Calculating</roe-three-dots-animation
            >
            <span v-else>Calculate</span>
          </button>
          {{ serverMessage }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RoeArchivedDesigns from "@/components/alternative-designs/_shared/ArchivedDesigns";
import RoeDesignActions from "@/components/alternative-designs/_shared/DesignActions";
import {
  RoeAgeRequirement,
  RoeServiceRequirement,
  RoeAutoEnrollment,
  RoeAutoEscalation,
  RoeEmployerMatch,
  RoeEmployerOther
} from "@/components/alternative-designs/saving-behavior/plan-design-fields";
import {
  ALTERNATIVE_DESIGN_ADD_NEW,
  ALTERNATIVE_DESIGNS_CALCULATE_SAVING,
  FETCH_AVAILABLE_SELECT_OPTIONS,
  FETCH_COMPLIANCE_LIMITS
} from "@/store/actions.type";
import { ALTERNATIVE_DESIGNS_HIGHLIGHT_DIFFERENCES_CHANGE } from "@/store/mutations.type";
import { mapGetters, mapActions, mapMutations } from "vuex";
import RoeEditPlanDesignName from "@/components/alternative-designs/_shared/EditPlanDesignName";
import RoeThreeDotsAnimation from "@/components/_shared/ThreeDotsAnimation";
import WebNotificationsChannelMixin from "@/components/_shared/mixins/WebNotificationsChannelMixin";
export default {
  name: "RoePlanDesignsTable",
  components: {
    RoeThreeDotsAnimation,
    RoeEditPlanDesignName,
    RoeDesignActions,
    RoeArchivedDesigns,
    RoeAgeRequirement,
    RoeServiceRequirement,
    RoeAutoEnrollment,
    RoeAutoEscalation,
    RoeEmployerMatch,
    RoeEmployerOther
  },
  mixins: [WebNotificationsChannelMixin],
  watch: {
    calculating: function(prevValue, newValue) {
      if (!prevValue && newValue)
        this.$scrollTo("#lead-indicators-track", 1000);
    }
  },
  computed: {
    ...mapGetters(["designs", "highlightDifferences", "calculating"])
  },
  mounted() {
    this.$store.dispatch(FETCH_AVAILABLE_SELECT_OPTIONS);
    this.$store.dispatch(FETCH_COMPLIANCE_LIMITS);
  },
  methods: {
    ...mapActions({
      addNew: ALTERNATIVE_DESIGN_ADD_NEW,
      calculateSaving: ALTERNATIVE_DESIGNS_CALCULATE_SAVING
    }),
    ...mapMutations({
      changeHighlightDifferences: ALTERNATIVE_DESIGNS_HIGHLIGHT_DIFFERENCES_CHANGE
    }),
    canAddCurrentDesign() {
      if (this.designs.length === 4) {
        this.flashMessage.error({
          title: "Error",
          message:
            "You cannot see more than 3 alternative designs at the same time.\n" +
            "\n" +
            "Please, archive or delete one or several designs to be able to add another one."
        });
      }
    },
    openEditNameForm(design) {
      this.$refs.editPlanDesignNameForm.open(design);
    }
  }
};
// Vue.config.errorHandler = function(err, vm, info) {
//   vm.flashMessage.error({
//     title: 'Error',
//     message: 'Something went wrong.'
//   })
// };
</script>
